<template>
  <v-app-bar color="primary" :elevation="2">
    <template v-slot:prepend>
      <v-img class="ml-2" src="@/assets/images/logo.png" width="60" />
    </template>
    <v-app-bar-title>PLATAFORMA DE FORMACIÓN</v-app-bar-title>
  </v-app-bar>
</template>
<script setup>
  import { onMounted } from "vue";
  import { useRouter } from 'vue-router'

  const router = useRouter()

  onMounted(()=>{
    if(!localStorage.tokenaccess){
      router.push({name: "access"})
    }
  })
</script>